import { Fragment } from "react/jsx-runtime";
import InteractiveSurveyContactPreview from "./InteractiveSurveyContactPreview";

export interface InteractiveSurveyContactPreviewListProps {
  surveyContactList: Array<{
    contactId: string;
    name: string;
    title?: string;
    licenseNo?: string;
    email: string;
    phoneNumber?: string;
    order: number;
  }>;
}

function InteractiveSurveyContactPreviewList({
  surveyContactList,
}: InteractiveSurveyContactPreviewListProps) {
  // Sort contacts by order
  const sortedContacts = [...surveyContactList].sort(
    (a, b) => (a.order || 0) - (b.order || 0),
  );

  if (sortedContacts.length === 0) {
    return null;
  }

  return (
    <div className="p-3 w-auto bg-[#CBD1D3] relative max-w-[312px] md:max-w-none flex flex-col md:flex-row">
      {/* "Your CBRE Team" Label */}
      <div className="mb-0 md:mb-0 md:w-auto md:self-center md:mr-0">
        <p className="contact-label">Your CBRE Team</p>
      </div>

      {/* Contact Cards */}
      <div className="divide-solid divide-cbre-green divide-y max-w-[95vw] md:divide-x md:divide-y-0 grid grid-cols-[repeat(auto-fit,minmax(250px,1fr))]">
        {sortedContacts.map((contact) => (
          <Fragment key={contact.contactId}>
            <InteractiveSurveyContactPreview surveyContact={contact} />
          </Fragment>
        ))}
      </div>
    </div>
  );
}

export default InteractiveSurveyContactPreviewList;
